import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export const PrivateValidator = ({ children }) => {
    const { auth } = useAuth()

    return auth.logged ? children : <Navigate to='/login' />
}
